<template>
  <div class="reportWrapper">
    <template v-if="jsonReady">
      <!-- {{helpJsonContent}} -->
      <div class="report-component" id="insider-leading-indicators">
        <h3 class="margin-bottom--quarter">
          {{ momentFormat(issue, 'MMMM YYYY') }} Report
        </h3>

        <h4>{{ helpJsonContent.leading_indicator.page_title }}</h4>

        <p class="advisor-capped-title">
          {{ helpJsonContent.leading_indicator.section_title }}
        </p>

        <p
          class="margin-top--quarter"
          v-html="helpJsonContent.leading_indicator.body"
        ></p>

        <div class="scrollable-image margin-top">
          <img
            :src="
              images_path +
              helpJsonContent.leading_indicator.image1.attributes.href
            "
            alt="Insider Leading Indicators Image"
          />
        </div>

        <p class="image-note">
          {{ helpJsonContent.leading_indicator.footnote1 }}
        </p>
      </div>
    </template>
  </div>
</template>

<script>
  import moment from 'moment';
  export default {
    props: {
      content: {
        type: String,
        required: true,
      },
      imagespath: {
        type: String,
        required: true,
      },
      issue: {
        type: String,
        required: false,
      },
    },
    data: function () {
      return {
        parsed: {},
        jsonReady: true,
        summary: '',
        images_path: this.imagespath,
      };
    },
    computed: {
      helpJsonContent: function () {
        //return JSON.parse(this.content.replace("\\u2029 | \\u2028", "<br>"));
        return JSON.parse(this.content);
      },
    },
    methods: {
      momentFormat(date, format) {
        return moment(date).format(format);
      },
      parseJson: function () {
        this.jsonReady = true;
        // this.summary = this.parsed.Root.mid_col.overview_block[0].body_copy.__text;
      },
    },
  };
  //https://stackoverflow.com/questions/13869627/unable-to-access-json-property-with-dash  jsonObj.profile - id
  //To access a key that contains characters that cannot appear in an identifier, use brackets: jsonObj["profile-id"]
</script>
